import { FC, memo } from 'react'
import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import { CurrencyAndLocation } from '@/components/Inputs'
import BottomDrawer from '../../BottomDrawer'
import SummarySidebar from '../../LayoutWithSummary/SummarySidebar'
import { cartDrawerStyle as styles } from './CartDrawer.style'
import { CartDrawerProps } from './CartDrawer.types'
import PackageSummary from './PackageSummary'
import { useCartDrawerController } from './CartDrawer.controller'

const CartDrawer: FC<CartDrawerProps> = ({ open, onClose }) => {
  const { t, isMobile, productCount, onCheckout, isInCheckoutFlow } = useCartDrawerController({
    onClose,
  })

  return (
    <BottomDrawer
      open={open}
      onOpen={onClose}
      onClose={onClose}
      heading={t('heading')}
      anchor={isMobile ? 'bottom' : 'right'}
      mainContentWrapperProps={{ sx: styles.mainContentWrapper }}
      contentWrapperProps={{ sx: styles.contentWrapper }}
      actionButtonProps={
        productCount > 0
          ? {
              primaryActionText: isInCheckoutFlow ? t('closeButton') : t('checkoutButton'),
              onPrimaryActionClick: onCheckout,
              wrapperProps: { sx: styles.actionButtonWrapper },
              primaryButtonProps: { sx: styles.actionPrimaryButton },
            }
          : undefined
      }>
      <>
        <PackageSummary />
        {productCount > 0 && <SummarySidebar hideLocationInfo />}
        {productCount === 0 && (
          <Box sx={styles.emptyWrapper}>
            <Text>{t('empty')}</Text>
          </Box>
        )}
        <Box sx={styles.currencyAndLocation}>
          <CurrencyAndLocation />
        </Box>
      </>
    </BottomDrawer>
  )
}

export default memo(CartDrawer)
